import { HttpClient } from '@/modules/common/services/http/__deprecated__/base-http-client';

export function bankAccountsRegister(data = {}) {
  return HttpClient.put<any>('/api/v3/account/update', data);
}

export function bankAccountDelete(id: string) {
  return HttpClient.delete<any>(`api/v2/bank-accounts/single/${id}`);
}
